module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search"
    }
  }, [(_vm.projects && _vm.projects.length) ? _c('div', {
    staticClass: "sort"
  }, [_c('md-field', {
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-select', {
    on: {
      "md-selected": _vm.changeFilter
    },
    model: {
      value: (_vm.filter.project_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "project_id", $$v)
      },
      expression: "filter.project_id"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Проект: Все")]), _vm._l((_vm.projects), function(project) {
    return _c('md-option', {
      key: project.id,
      attrs: {
        "value": project.id
      }
    }, [_vm._v(_vm._s(project.name))])
  })], 2)], 1)], 1) : _vm._e(), (_vm.statuses && _vm.statuses.length) ? _c('div', {
    staticClass: "sort"
  }, [_c('md-field', {
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-select', {
    on: {
      "md-selected": _vm.changeFilter
    },
    model: {
      value: (_vm.filter.status_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "status_id", $$v)
      },
      expression: "filter.status_id"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Статус: Все")]), _vm._l((_vm.statuses), function(status) {
    return _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))])
  })], 2)], 1)], 1) : _vm._e(), (_vm.userFilter && _vm.userFilter.id) ? _c('md-chip', {
    staticClass: "small md-primary user-label",
    on: {
      "click": _vm.clearUser
    }
  }, [_vm._v(_vm._s((_vm.userFilter.fio) ? _vm.userFilter.fio : _vm.userFilter.login))]) : _vm._e(), (!_vm.userFilter || !_vm.userFilter.id) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchStringUser),
      expression: "searchStringUser"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "Ответственный"
    },
    domProps: {
      "value": (_vm.searchStringUser)
    },
    on: {
      "keyup": _vm.dropdown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchStringUser = $event.target.value
      }
    }
  }) : _vm._e(), (_vm.showSearchDropdown && _vm.searchStringUser) ? _c('ul', {
    staticClass: "dropdown md-elevation-1"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.filterUser(user)
        }
      }
    }, [_vm._v("Исполнитель "), _c('md-chip', [_vm._v(_vm._s((user.fio) ? (user.fio + ' (' + user.login + ')') : user.login))])], 1)
  })) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "Поиск..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFilter($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), (_vm.searchString.length) ? _c('md-button', {
    staticClass: "small md-icon-button close md-dense md-accent",
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('md-icon', [_vm._v("close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a266d68","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tasks/toolbars/SearchToolbar.vue
// module id = 1085
// module chunks = 0